
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import torok from "../../assets/torok.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarTorok({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar török fordító</title>
                <meta name='description' content="Ingyenes magyar török fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar török fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-torok-fordito" />
            </Helmet>
            <h1>Magyar török fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és török nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={torok} alt="török zászló"></img>
                </div>


                <p>A török és a magyar nyelv két nyelv, amelyek nem tartoznak ugyanahhoz a nyelvcsaládhoz, de bizonyos hasonlóságokat mutatnak egymással szemben. Íme néhány alapvető hasonlóság és különbség a török és a magyar nyelv között:</p>

                <h3>Hasonlóságok</h3>
                <ul>

                    

                    <li><b>Nyelvtani szerkezet</b>: Mind a török, mind a magyar nyelv agglutináló jellegű. Ez azt jelenti, hogy a szavak jelentése és a nyelvtani információk a szóban található ragokkal és kiegészítő elemekkel vannak kifejezve.</li>

                    <li><b>Szókincs</b>: Bár a török és a magyar nyelv szókincse alapvetően különbözik egymástól, vannak néhány szóban megtalálható hasonlóságok. Ezek a hasonlóságok azonban valószínűleg a Török Hódoltságra vezethető vissza.</li>
                </ul>

                <h3>Különbségek</h3>

                <ul>
                    <li><b>Hangrendszer</b>: A török és a magyar nyelv hangrendszere jelentősen eltér egymástól. Mind a két nyelvnek vannak olyan hangjai, amelyek a másikban nem találhatók meg.</li>

                    <li><b>Nyelvtani szerkezet</b>: Bár mind a török, mind a magyar nyelv agglutináló jellegű, a konkrét nyelvtani jelenségek és a ragok használata különbözik. A török nyelvben például jellemzőbbek a képzők, míg a magyar nyelvben inkább az igekötők és a névmásragok dominálnak.</li>

                    <li><b>Szórend</b>: A török nyelvben általában a SOV (alany-ige-állítmány) szórend a leggyakoribb, míg a magyar nyelvben a SVO (alany-ige-állítmány) szórend jellemzőbb.</li>

                    <li><b>Szókincs</b>: A török és a magyar nyelv szókincse is különböző. A török nyelvben az arab, perzsa és más közép-ázsiai nyelvekből származó kölcsönszavak jelentősek, míg a magyar nyelv inkább európai nyelvekből kölcsönzött szavakkal rendelkezik.</li>
                </ul>
               
                <div className="sectionbottom">
                    <Link to="/torok-magyar-fordito">Török magyar fordító</Link>
                    <img src={torok} alt="török zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarTorok;